import RoutePath from 'shared/utils/namedUrls';

const basePath = '/finances/';

export default {
  myCards: new RoutePath(`${basePath}my-cards/`),
  history: new RoutePath(`${basePath}history/`),
};
